export default __webpack_public_path__ + "static/media/jrc_logo_flat.41e15740.png";